import { type LandingPageMembershipTabData } from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent/LandingPageMembershipTabContentCard';

import auroraLandingPageMembershipTabData from './auroraLandingPageMembershipTabData';

type TrustedGuardianMembershipTabPanelOverrides = Partial<
  LandingPageMembershipTabData['tabPanel']
>;
type TrustedGuardianMembershipTabDataOverrides = Record<
  string,
  { tabPanel: TrustedGuardianMembershipTabPanelOverrides }
>;

const trustedAdvisorMembershipTabDataOverrides: TrustedGuardianMembershipTabDataOverrides =
  {
    stress: {
      tabPanel: {
        cards: [
          ...auroraLandingPageMembershipTabData[3]!.tabPanel.cards,
          {
            copy: 'cumulative_stress_feature_copy',
            image: {
              localizedAlt: 'cumulative_stress_app_ui_alt',
              localizedSrc: 'cumulative_stress_app_ui',
            },
            title: 'cumulative_stress_feature_title',
          },
        ],
      },
    },
  } as const;

export default trustedAdvisorMembershipTabDataOverrides;
